module.exports = __webpack_public_path__ + "img/logo.c4e26bb1.png";